import React from 'react'
import './SearchResults.css'

export default class SearchResults extends React.Component{
    render(){
        return(
            <div className = 'results-page'>
            <h1>Results</h1>
            <h2>List of Maladies</h2>
            </div>
        )
    }
}